//ablyft custom tracking

window.ablyft = window.ablyft || [];
    document.addEventListener('click', function (event) {
        var link = event.target.closest('a[href]');
        if (!link) return;

        if (link.getAttribute('href').indexOf('/products/') === -1) return;

        var productCollection = link.closest('.product-collection');
        if (!productCollection) return;

        if (!productCollection.querySelector('.product-badge')) return;

        window.ablyft.push({
        eventType: 'custom',
        eventName: 'product-link-click',
    });
});
